module.exports = __webpack_public_path__ + "static/media/centro_abajo_1(1).50021820.jpg";